export enum InstallAgentPanelEvents {
  OnPanelClose = 'installAgentPanelEventClose',
  OnViewInit = 'installAgentPanelOnViewInit',
}

export class OnInstallAgentPanelClose extends CustomEvent<{}> {
  constructor() {
    super(InstallAgentPanelEvents.OnPanelClose, {
      detail: {},
      bubbles: true,
      composed: true,
    });
  }
}

export class OnInstallAgentViewInit extends CustomEvent<{}> {
  constructor() {
    super(InstallAgentPanelEvents.OnViewInit, {
      detail: {},
      bubbles: true,
      composed: true,
    });
  }
}
